import * as Sentry from "@sentry/browser";
import Navigation from "./navigation";
import Animations from "./animations";
import Videoplayer from "./videoplayer";

document.addEventListener('DOMContentLoaded', function() {
    new Navigation();
    new Animations();
    new Videoplayer();
});

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found.');
}

Sentry.init({
    dsn: "https://d73b2b29975b41719da51308d7f0962b@o462328.ingest.sentry.io/5465598",
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 0.2,
    tracePropagationTargets: ["bbn.local", /^https:\/\/blivbrandmandnu\.dk/],
});
